import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueRewardAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        itemId: route.params.itemId,
        tier: route.params.tier,
        position: '',
        tierReward: 0,
        starReward: 0,
        rubyReward: 0
    });

    const validations = {
        position: { required, numeric, min: minValue(0), max: maxValue(3200) },
        tierReward: { required, numeric, min: minValue(0), max: maxValue(3200) },
        starReward: { required, numeric, min: minValue(0), max: maxValue(3200) },
        rubyReward: { required, numeric, min: minValue(0), max: maxValue(3200) }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = crudAction.executeAction({
        request: () => leagueService.tier.get(model.itemId, model.tier),
        onError: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            leagueService.reward.create(
                model.itemId,
                model.tier,
                model.position,
                model.tierReward,
                model.starReward,
                model.rubyReward
            ),
        onSuccess: () =>
            router.push({
                name: ROUTE_NAME_LEAGUE.TIER.REWARD.INDEX,
                params: { itemId: model.itemId, tier: model.tier }
            })
    });

    return { model, v$, beforeFetch, create };
}
